export const HANDLE_SEARCH_QUERY = "HANDLE_SEARCH_QUERY";

export const GET_BOOKMARKS_FETCH_STARTED = "GET_BOOKMARKS_FETCH_STARTED";
export const GET_BOOKMARKS_FETCH_COMPLETED = "GET_BOOKMARKS_FETCH_COMPLETED";
export const GET_BOOKMARKS_FETCH_FAILED = "GET_BOOKMARKS_FETCH_FAILED";

export const UPDATE_BOOKMARKED_STARTED = "UPDATE_BOOKMARKED_STARTED";
export const UPDATE_BOOKMARKED_COMPLETED = "UPDATE_BOOKMARKED_COMPLETED";
export const UPDATE_BOOKMARKED_FAILED = "UPDATE_BOOKMARKED_FAILED";
